import { useEffect, useState } from "react"
import { getPartners, getPartnersCities } from "../api"

const transformData = recyclingTypes => {
  const points = {}
  const transformedRecyclingTypes = []

  recyclingTypes.forEach(recyclingType => {
    const currentRecyclingType = {
      id: recyclingType.id,
      title: recyclingType.title,
      count: 0,
      locations: [],
    }

    recyclingType.partners.forEach(partner => {
      partner.locations.forEach(location => {
        if (!points[location.id]) {
          points[location.id] = {
            id: [recyclingType.id, partner.id, location.id].join("-"),
            title: partner.title,
            recyclingType: {
              id: recyclingType.id,
              title: recyclingType.title,
            },
            services: [
              {
                id: recyclingType.id,
                title: recyclingType.title,
              },
            ],
            phone: partner.phoneNumber,
            email: partner.email,
            fullAddress: location.fullAddress,
            city: location.city,
            coordinates: [
              Number(location.longitude),
              Number(location.latitude),
            ],
          }

          currentRecyclingType.count += 1
          currentRecyclingType.locations.push({
            city: location.city,
            fullAddress: location.fullAddress,
          })
        }
      })
    })

    transformedRecyclingTypes.push(currentRecyclingType)
  })

  return {
    points: Object.values(points),
    recyclingTypes: transformedRecyclingTypes,
  }
}

const useRecycles = () => {
  const [data, setData] = useState({
    cities: [],
    recyclingTypes: [],
    points: [],
    totalCount: 0,
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const load = async () => {
    try {
      setLoading(true)
      const partnersPromise = getPartners()
      const citiesPromise = getPartnersCities()
      const [citiesData = [], partnersData] = await Promise.all([
        citiesPromise,
        partnersPromise,
      ])

      const { recyclingTypes, points } = transformData(
        partnersData.recyclingTypes
      )

      setData({
        cities: citiesData.map(({ city, partnersCount }, idx) => ({
          id: idx,
          city,
          count: partnersCount,
        })),
        recyclingTypes,
        points,
        totalCount: partnersData.partnerPointsCount,
      })
    } catch (e) {
      // произошла ошибка при загрузке
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  return { data, loading, error }
}

export default useRecycles
